const DESKTOP_MIN = 992
const TABLET_MIN = 768

export const mediaDesktop = `@media (min-width: ${DESKTOP_MIN}px)`

export const mediaTablet = `@media (min-width:  ${TABLET_MIN}px) and (max-width: ${DESKTOP_MIN - 1}px)`

export const mediaMobile = `@media (max-width:  ${TABLET_MIN - 1}px)`

export const mediaTabletAndMobile = `@media(max-width:  ${DESKTOP_MIN - 1}px)`
